<script lang="ts">
  interface Team {
    slug: string;
    name: string;
    day_of_week: string | null;
    time_slot: string | null;
    description: string | null;
    kakao_url: string | null;
    kakao_code: string | null;
    member_count: number;
  }

  interface Props { teams: Team[]; }
  let { teams }: Props = $props();

  const dayKor: Record<string, string> = {
    mon: '월', tue: '화', wed: '수', thu: '목', fri: '금', sat: '토', sun: '일'
  };
  const slotKor: Record<string, string> = {
    morning: '오전', afternoon: '오후', evening: '저녁'
  };
  function dayLabel(t: Team): string {
    return [t.day_of_week ? dayKor[t.day_of_week] : '', t.time_slot ? slotKor[t.time_slot] : '']
      .filter(Boolean).join(' ');
  }
</script>

<div class="p-6 space-y-6">
  <header>
    <h1 class="text-2xl font-bold">스터디 팀 관리</h1>
    <p class="text-sm text-gray-600 mt-1">tier(Blue/Green/Yellow)와 별개로 운영하는 모임 분반</p>
  </header>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    {#each teams as t}
      <div class="bg-white border rounded-lg p-5 hover:border-blue-400 hover:shadow transition">
        <div class="flex items-start justify-between mb-2">
          <h2 class="text-lg font-bold">{t.name}</h2>
          <span class="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded">
            {t.member_count}명
          </span>
        </div>
        {#if dayLabel(t)}<div class="text-sm text-gray-600 mb-2">📅 {dayLabel(t)}</div>{/if}
        {#if t.description}<div class="text-xs text-gray-500 mb-3">{t.description}</div>{/if}
        <div class="flex gap-2 mt-3">
          <a href="/admin/community/study_teams/{t.slug}"
             class="text-xs px-3 py-1.5 bg-gray-700 text-white rounded hover:bg-gray-800">
            👥 멤버 보기
          </a>
          <a href="/admin/community/study_teams/{t.slug}/attendance"
             class="text-xs px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700">
            📅 출석 캘린더
          </a>
          {#if t.kakao_url}
            <a href={t.kakao_url} target="_blank" rel="noopener noreferrer"
               class="text-xs px-3 py-1.5 border border-gray-300 rounded hover:bg-gray-50">
              💬 오픈톡방
            </a>
          {/if}
        </div>
      </div>
    {/each}
  </div>

  {#if teams.length === 0}
    <div class="p-8 text-center text-gray-500 bg-gray-50 rounded">등록된 팀이 없습니다.</div>
  {/if}
</div>
